import React, { useState, useEffect, Suspense } from "react";
import "../../css/admin.css";
import Chart from "react-apexcharts";
import $ from "jquery";
import { useLocation } from "react-router-dom";
import { awsAPIUrlcommon } from "../../apiService";
const folderName = window.sessionStorage.getItem("homeName");
const Header = React.lazy(() => import("../../" + folderName + "/header"));
const Footer = React.lazy(() => import("../../" + folderName + "/footer"));
const colors = ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#00D9E9', '#FF66C3'];
const PollReport = () => {
    const location = useLocation();
    let data
    const [showingCondentData, setShowingCondentData] = useState([]);
    useEffect(() => {
        if (location?.state) {
            ({ data } = location.state);
            getPollGraphDetails(data);
        }

    }, []);
    const getPollGraphDetails = (data) => {
        $(".loader").show();
        const postData = {
            method: "POST",
            body: JSON.stringify({
                "functionName": "getUserPollAnalytics",
                "pollId": data
            })
        };
        awsAPIUrlcommon(postData)
            .then((data) => {
                if (data?.success === "1") {
                    setShowingCondentData(data.result[0]);
                    $(".loader").hide();
                } else {
                    $(".loader").hide();
                    alert("Something went wrong");
                }
            })
            .catch((error) => {
                $(".loader").hide();
                console.error("Error sending notification:", error);
                alert("An error occurred while sending notification");
            });
    };
    // function formatDate(timestamp) {
    //     if (timestamp) {
    //         const date = new Date(timestamp);
    //         const day = date.getUTCDate().toString().padStart(2, '0');
    //         const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    //         const year = date.getUTCFullYear();
    //         const formattedDate = `${day}-${month}-${year}`;
    //         return formattedDate;
    //     } else { return "NoData Available" }
    // }
    return (
        <div className="purpleWrap bg-clr-wthHead">
            <Suspense fallback={<div>Waiting...</div>}>
                <section>
                    <Header />
                    <div className="loader"></div>
                    <div className="container mb-5">
                        <div>
                            <ul className="breadcrum-adminMangmnt">
                                <li>
                                    <a href="/admin/dashboard">Dashboard</a>
                                </li>
                                <li>
                                    <a href="/adminManagement/poll-list">Poll List</a>
                                </li>
                                <li>
                                    <a href="" className="current">
                                        Poll Report
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="head-hospMangmntList">PollReport</div>
                        {showingCondentData?.userPollDetails?.length ?
                            <ul className="poll-report-ul">
                                <li className="poll-report-li">
                                    <div className="poll-report-head" >
                                        Poll Title : <span className="poll-report-head-span">{showingCondentData.pollName}</span>
                                    </div>
                                    {showingCondentData?.userPollDetails?.map((data, i) => (
                                        <div className="poll-report-div" key={i}>
                                            <div className="poll-report-chart">
                                                <div>
                                                    <div id={`chart-${i}`}>
                                                        <Chart
                                                            options={{
                                                                chart: {
                                                                    height: 350,
                                                                    type: 'bar',
                                                                    toolbar: {
                                                                        show: false,
                                                                    }
                                                                },
                                                                tooltip: {
                                                                    enabled: true,
                                                                },
                                                                colors: colors,
                                                                plotOptions: {
                                                                    bar: {
                                                                        columnWidth: '25%',
                                                                        distributed: true,
                                                                    }
                                                                },
                                                                dataLabels: {
                                                                    enabled: false
                                                                },
                                                                legend: {
                                                                    show: false
                                                                },
                                                                xaxis: {
                                                                    categories: data.userPollDetails.map(answer => answer.answer),
                                                                    labels: {
                                                                        style: {
                                                                            colors: colors,
                                                                            fontSize: '12px'
                                                                        },
                                                                        show: false
                                                                    }
                                                                },
                                                                yaxis: {
                                                                    labels: {
                                                                        formatter: function (val) {
                                                                            return Math.round(val); // Round the value to the nearest integer
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                            series={[
                                                                {
                                                                    name: 'Total Counts',
                                                                    data: data.userPollDetails.map(answer => answer.totalCount)
                                                                }
                                                            ]}
                                                            type="bar"
                                                            height={350}
                                                        />
                                                    </div>
                                                    <div id={`html-dist-${i}`}></div>
                                                </div>
                                            </div>
                                            {/* } */}
                                            <div className="poll-report-view">
                                   <p className="poll-body-question" key={i}>{i + 1}. {data.pollQuestions}</p>
                                       {data.userPollDetails.map((answer, j) => (
                                           <div className="pl-4 mb-2">
                                               <div className="poll-report-view-head">
                                                   {j + 1}. {answer.answer}
                                               </div>
                                               {answer.pollUsers.length ?
                                                   <div className="poll-report-body">
                                                       <ol className="pr-md-5">
                                                       {answer.pollUsers.map((items, o) => (
                                                           items.userDisplayName&&(
                                                           <li className="">
                                                               <p className="poll-body-text" key={o}> 
                                                                  <span className="float-left">{items.userDisplayName}  </span> 
                                                                  <span className="float-right">{items.mobile_number} </span>
                                                               </p>
                                                           </li>
                                                           )
                                                       ))}
                                                       </ol>
                                                       {/* {items.email_id &&
                                                       <p className="poll-body-text">E-Mail :{items.email_id}</p>}
                                                   {items.mobile_number &&
                                                       <p className="poll-body-text">Mob No :{items.mobile_number}</p>}
                                                   {items.userPollCreatedDate &&
                                                       <p className="poll-body-text">Created Date :{formatDate(items.userPollCreatedDate)}</p>} */}
                                                   </div>
                                               :<p className="poll-body-text"> No one Answered Yet</p>}
                                           </div>
                                       ))}
                                   </div>
                                        </div>
                                    ))}
                                </li>
                            </ul>
                            : <div className="text-center">No DataFound</div>}
                    </div>
                    {folderName !== null && <Footer />}
                </section>
            </Suspense>
        </div>
    );
};

export default PollReport;
